import { render, staticRenderFns } from "./poster-normal.vue?vue&type=template&id=6acff370&scoped=true&"
import script from "./poster-normal.vue?vue&type=script&lang=js&"
export * from "./poster-normal.vue?vue&type=script&lang=js&"
import style0 from "./poster-normal.vue?vue&type=style&index=0&id=6acff370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acff370",
  null
  
)

export default component.exports